import * as React from "react";
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import MenuPlanning1 from "../planning/MenuPlanning1";
// import DialogItemDetail from "./DialogItemDetail";
import { makeStyles } from "@mui/styles";
import Button from "../Button";
// import DialogManageWorkload from "./DialogManageWorkload";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PdfIcon from "../../assets/images/pdf.png";

import cssVariables from "../../theme/cssVariables";


const styles = {
  td: {
    fontSize: "18px",
    lineHeight: "24.59px",
  },
  emtyData: {
    fontSize: "18px",
    lineHeight: "24.59px",
    color: "#A0A0A0",
  },
  span: {
    fontWeight: "500",
    textDecoration: "underline",
  },
};
function Row(props) {
  const { row, classes, param, rubricCat, itemIndex } = props;
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const childrenRows = row.items ? row.items : [];
  const useStyles = makeStyles({
    tableBody: {
      backgroundColor: "unset !important",
      boxShadow: "none !important",
    },
    expandableIcon: {
      background: "#F5F5F5",
      // padding: 3,
      width: '20px',
      height: '20px',
      borderRadius: 3,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: '.3s',
      '&.active': {
        transform: "rotate(90deg)",
      }
    },
  });
  const classess = useStyles();
  return (
    <React.Fragment>
      <TableRow>
        <TableCell colSpan={8} sx={{ padding: "10px 0px" }}>
          <TableContainer
            sx={{ border: "1px solid #E4E4E4", borderRadius: "10px" }}
          >
            <Table>
              <TableBody
                component={Paper}
                classes={{ root: classess.tableBody }}
              >
                <TableRow sx={{ "background-color": "white" }}>
                  <TableCell sx={{ width: param.colWidth01 }}>
                    {/* <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => setOpen(!open)}
                    >
                      {open ? (
                        <KeyboardArrowDownIcon />
                      ) : (
                        <KeyboardArrowRightIcon />
                      )}
                    </IconButton> */}
                    <div className={`clickable ${classess.expandableIcon} ${ open ? 'active' : ''}`} onClick={() => setOpen(!open)}><ArrowForwardIosIcon sx={{ fontSize: "0.9rem" }} /></div>
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth02 }} style={styles.td}>
                    {row.rubricCode}
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth03 }} style={styles.td}>
                    {row.rubricDesc} <br />
                    <Typography
                      component={"div"}
                      sx={{
                        "font-weight": "bold",
                        display: row.rubricRemark ? "inline" : "none",
                        color: "#939393",
                      }}
                    >
                      {t("label.remark")}:
                      <Typography sx={{ display: "inline" }} pl={1}>
                        {row.rubricRemark}
                      </Typography>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth04 }} style={styles.td}>
                    {row.amount} {row.unit}
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth05 }} style={styles.td}>
                    {row.valueofwork}
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth06 }}>
                    <Typography style={styles.td}>{row.score}</Typography>
                  </TableCell>
                  <TableCell
                    sx={{ width: param.colWidth07, "text-align": "end" }}
                  >
                    {/* <MenuPlanning1
                      rubricCat={rubricCat}
                      itemIndex={itemIndex}
                      row={row}
                    /> */}
                  </TableCell>
                  <TableCell sx={{ width: param.colWidth08 }}></TableCell>
                </TableRow>
                <TableRow sx={{ "background-color": "#F5F5F5" }}>
                  <TableCell colSpan={8} sx={{ padding: "0px" }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ "background-color": "#33619926" }}>
                            <TableCell
                              sx={{ width: param.colWidth01 }}
                            ></TableCell>
                            <TableCell
                              sx={{ width: param.colWidth02 }}
                            ></TableCell>
                            <TableCell
                              sx={{ width: param.colWidth03 }}
                              colSpan={6}
                            >
                              <Box sx={{ display: "flex", alignItems: "center"}}>
                                <Typography
                                  fontWeight="500"
                                  sx={{ color: "#404349" }}
                                  pr={1}
                                >
                                  รายละเอียดภาระงาน
                                </Typography>
                                <Typography
                                  sx={{ color: "#404349", fontSize: "13px" }}
                                >
                                  (ภาระงานที่แสดงผล
                                  เป็นเพียงการดึงข้อมูลเบื้องต้นมาจากระบบเท่านั้น
                                  สามารถแก้ได้หรือเปลี่ยนแปลงได้ภายหลัง)
                                </Typography>
                              </Box>
                            </TableCell>
                            {/*<TableCell sx={{ width : param.colWidth04}}>{t('label.amountOfWork')}</TableCell>*/}
                            {/*<TableCell sx={{ width : param.colWidth05}}>{t('label.workValue')}</TableCell>*/}
                            {/*<TableCell sx={{ width : param.colWidth06}}>{t('label.score')}</TableCell>*/}
                            {/*<TableCell sx={{ width : param.colWidth07}}></TableCell>*/}
                          </TableRow>
                        </TableHead>
                        <TableHead sx={{ "background-color": "#F9FBFD" }}>
                          <TableRow>
                            <TableCell
                              sx={{ width: param.colWidth01 }}
                            ></TableCell>
                            <TableCell
                              sx={{ width: param.colWidth02 }}
                              className={classes["td-underline"]}
                            >
                              {t("label.code")}
                            </TableCell>
                            <TableCell
                              sx={{ width: param.colWidth03 }}
                              className={classes["td-underline"]}
                            >
                              {t("label.workloadDetail")}
                            </TableCell>
                            <TableCell
                              sx={{ width: param.colWidth04 }}
                              className={classes["td-underline"]}
                            >
                              {t("label.amountOfWork")}
                            </TableCell>
                            <TableCell
                              sx={{ width: param.colWidth05 }}
                              className={classes["td-underline"]}
                            >
                              {t("label.workValue")}
                            </TableCell>
                            <TableCell
                              sx={{ width: param.colWidth06 }}
                              className={classes["td-underline"]}
                            >
                              {t("label.score")}
                            </TableCell>
                            <TableCell
                              sx={{ width: param.colWidth07 }}
                              className={classes["td-underline"]}
                            ></TableCell>
                            <TableCell
                              sx={{ width: param.colWidth08 }}
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{ "background-color": "#F9FBFD" }}>
                          {!childrenRows.length ? (
                            <TableRow>
                              <TableCell colSpan={8} align="center">
                                ยังไม่มีข้อมูล
                              </TableCell>
                            </TableRow>
                          ) : (
                            childrenRows.map((loItem, lvIndex) => (
                              <TableRow key="row.itemCode">
                                <TableCell
                                  sx={{ width: param.colWidth01 }}
                                ></TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth02 }}
                                  className={classes["td-children-underline"]}
                                >
                                  {loItem.itemCode}
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth03 }}
                                  className={classes["td-children-underline"]}
                                >
                                  {loItem.itemDesc}
                                  <br />
                                  <Typography
                                    variant="dashed-solid"
                                    pr={1}
                                    pl={1}
                                    sx={{
                                      display: loItem.regFlag
                                        ? "inline"
                                        : "none",
                                      border: "1px solid #393939",
                                      borderRadius: "4px",
                                      fontSize: "13px",
                                      // 'padding-left': '5px',
                                      // 'padding-right': '5px'
                                    }}
                                  >
                                    REG
                                  </Typography>
                                  <Box p={0} sx={{display:"flex", alignItems: "center"}} mt={1}>
                                    <img
                                        src={PdfIcon}
                                        alt="pdf"
                                        style={{width: "20px", height: "20px"}}
                                    />
                                    <Typography sx={{marginLeft: 1}} variant="sub_label_2"><u>ตัวอย่างไฟล์.pdf</u></Typography>
                                  </Box>
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth04 }}
                                  className={classes["td-children-underline"]}
                                >
                                  {loItem.amount} {loItem.unit}
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth05 }}
                                  className={classes["td-children-underline"]}
                                >
                                  {loItem.value}{" "}
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth06 }}
                                  className={classes["td-children-underline"]}
                                >
                                  <Typography color="primary">
                                    {loItem.score}
                                  </Typography>{" "}
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth07 }}
                                  className={classes["td-children-underline"]}
                                >
                                  {/* <DialogItemDetail /> */}
                                </TableCell>
                                <TableCell
                                  sx={{ width: param.colWidth08 }}
                                ></TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

export default function CollapsibleTable(props) {
  const { t } = useTranslation();
  const { data, rubricCat } = props;
  const [open, setOpen] = React.useState(true);
  const param = {
    colWidth01: "60px",
    colWidth02: "90px",
    colWidth03: "auto",
    colWidth04: "150px",
    colWidth05: "150px",
    colWidth06: "150px",
    colWidth07: "150px",
    colWidth08: "60px",
  };
  const useStyles = makeStyles({
    "td-underline": {
      "border-bottom": "1px solid #A0A0A0 !important",
      // "border": "1px solid #A0A0A0 !important",
      color: "#A0A0A0 !important",
    },
    "td-children-underline": {
      "border-bottom": "1px solid #E5E5E5 !important",
      // "border": "1px solid #E5E5E5 !important",
      color: "#404349 !important",
    },
    tableBody: {
      backgroundColor: "unset !important",
      boxShadow: "none !important",
    },
  });
  const classes = useStyles();
  return (
    // { data.length = ? ("not havve"): ()}
    // { 1 === 0 ? "yesy" : "no"}
    <>
      <TableContainer>
        <Table
          aria-label="collapsible table"
          sx={{
            "border-collapse": "separate",
            "border-spacing": "0 14px",
            [`& .${tableCellClasses.root}`]: {
              borderBottom: "none",
              verticalAlign: "top"
            }
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: param.colWidth01 }}></TableCell>
              <TableCell
                sx={{ width: param.colWidth02 }}
                className={classes["td-underline"]}
              >
                <Typography variant="label" color="#A0A0A0">
                  {t("label.code")}
                </Typography>
              </TableCell>
              <TableCell
                sx={{ width: param.colWidth03 }}
                className={classes["td-underline"]}
              >
                <Typography variant="label" color="#A0A0A0">
                  {t("label.evalDetail")}
                </Typography>
              </TableCell>
              <TableCell
                sx={{ width: param.colWidth04 }}
                className={classes["td-underline"]}
              >
                <Typography variant="label" color="#A0A0A0">
                  {t("label.amountOfWork")}
                </Typography>
              </TableCell>
              <TableCell
                sx={{ width: param.colWidth05 }}
                className={classes["td-underline"]}
              >
                <Typography variant="label" color="#A0A0A0">
                  {t("label.workValue")}
                </Typography>
              </TableCell>
              <TableCell
                sx={{ width: param.colWidth06 }}
                className={classes["td-underline"]}
              >
                <Typography variant="label" color="#A0A0A0">
                  {t("label.score")}
                </Typography>
              </TableCell>
              <TableCell
                sx={{ width: param.colWidth07 }}
                className={classes["td-underline"]}
              >
                {" "}
              </TableCell>
              <TableCell sx={{ width: param.colWidth08 }}> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody classes={{ root: classes.tableBody }}>
            {!data.length ? (
              <TableRow>
                <TableCell colSpan={8} sx={{ padding: "10px 0" }}>
                  <TableContainer
                    sx={{ border: "1px solid #E4E4E4", borderRadius: "10px" }}
                  >
                    <Table>
                      <TableBody component={Paper}>
                        <TableRow
                          sx={{ "background-color": "white" }}
                          component={Paper}
                        >
                          <TableCell
                            colSpan={8}
                            align="center"
                            style={styles.emtyData}
                          >
                            ยังไม่มีข้อมูล
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow>
            ) : (
              data.map((row, lvIndex) => (
                <Row
                  key={row.name}
                  row={row}
                  param={param}
                  itemIndex={lvIndex}
                  classes={classes}
                  rubricCat={rubricCat}
                />
              ))
            )}
            {/*{data.map((row) => (*/}
            {/*    <Row key={row.name} row={row} param={param} classes={classes}/>*/}
            {/*))}*/}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
